import { render, staticRenderFns } from "./MarketplaceTransactionPage.vue?vue&type=template&id=753eaf4a&scoped=true&"
import script from "./MarketplaceTransactionPage.vue?vue&type=script&lang=js&"
export * from "./MarketplaceTransactionPage.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceTransactionPage.vue?vue&type=style&index=0&id=753eaf4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753eaf4a",
  null
  
)

export default component.exports